import axios from '@/axios'
import * as types from '../mutation-types'

export default {
	namespaced: true,
	
	state: {
		centers: []
	},

	actions: {
		fetchAll({ commit }) {
			return axios.get('/centers').then(({ data }) => {
				commit(types.STORE_CENTERS, data);
				return data;
			})
		},

		reset({ commit }) {
			commit(types.RESET);
		}
	},

	mutations: {
		[types.STORE_CENTERS](state, centers) {
			state.centers = centers;
		},
		[types.RESET](state) {
			state.centers = [];
		}
	}
}